export { default } from "ember-stereo/helpers/load-sound";
